var AT_AjaxSearch = {
  ajaxProductItems : function( input_element, result_wrapper, result_element ){
    
    var search_url  = '/search'
        ,result     = new Array()
        ,_keyword   = input_element.val().trim();

  
    
    jQuery.ajax({
        type: 'GET',
        data: {
            q: "*" + _keyword + "*",
            type: "product",
            view: "json",
        },
        dataType: "json",      
        url: search_url,
        complete:function(){
            jQuery('.searchbox').removeClass("s-loading");
        },
        success: function ( json_reponse ) {
          result_element.html(" ");
          if( json_reponse.length > 1 ){
            for (var i = 0; i < json_reponse.length-1; i++) {

              var item              = json_reponse[i];
              var produ_url = item.url;
              var productIndex = produ_url.indexOf("/products/");
              var productUrl = produ_url.substring(productIndex + 1);
    
                  var title            = item.title
                  ,price            = item.price
                  ,handle           = "/"+productUrl
                  ,image            = item.thumbnail
                  ,price            = item.price_min
//                   ,markedString     = title.replace(new RegExp('(' + _keyword + ')', 'gi'), '<span class="marked">$1</span>')
                  ,markedString     = title
                  ,template         = '<li class="result-item just-added" style="display:none;">'
                                      +'<a class="result-item-block" href="'+ handle +'" >'
                                      + '<div class="search-item-img">'
                                      + '<img style="max-width: 100px;" src="' + image + '" />' 
                                      +'</div>'
                                      +'<div class="search-item" >' + '<div class="search-item-title">'+markedString+'</div>'
                                      +'<span class="search-item-price">'+ price + '</span>'
              						  +'</div>'
	              					  +'</a>'
                                      +'</li>';

              
                 result_element.append(template);
                 setTimeout(function() {
                    result_element.children('li.result-item.just-added').removeClass('just-added').slideDown(600);
                 },300); 
            }
            
            if($('.result-ajax-search .search-results li').length){
              $('.result-ajax-search').show();
              
            }
          }else{

              jQuery.ajax({
                  type: 'GET',
                  data: {
                      q: "*" + _keyword + "*",
                      type: "page",
                      view: "json",
                  },
                  dataType: "json",      
                  url: search_url,
                  complete:function(){
                      jQuery('.searchbox').removeClass("s-loading");
                  },
                  success: function ( json_reponse ) {
                    console.log("json_reponse", json_reponse);
                    
                      result_element.html(" ");
                    if( json_reponse.length > 1 )
                    {
                    for (var i = 0; i < json_reponse.length-1; i++){
                        
                        var item              = json_reponse[i]
                            ,title            = item.title
                            ,price            = item.price
                            ,handle           = item.url     
                            ,price            = item.price_min
          //                   ,markedString     = title.replace(new RegExp('(' + _keyword + ')', 'gi'), '<span class="marked">$1</span>')
                            ,markedString     = title;
                           
                            var template         = '<li class="result-item just-added" style="display:none;">'
                                                +'<a class="result-item-block" href="'+ handle +'" >'
                                                +'<div class="search-item" >' + '<div class="search-item-title">'+markedString+'</div>'
                                                +'<span class="search-item-price">'+ price + '</span>'
                        						  +'</div>'
          	              					  +'</a>'
                                                +'</li>';
                           result_element.append(template);
                           setTimeout(function() {
                              result_element.children('li.result-item.just-added').removeClass('just-added').slideDown(600);
                           },300); 
                      }
                    }
                    else
                    {
                        result_element.html('<li class="result-item"><p>Ingen resultater funnet for søket ditt.</p></li>');
                         $('.result-ajax-search').show();
                    }
                  }
                })
                      
                
              }
       }     
    });

  

  }

  ,ajaxSearch : function( bc_search_config  ){
    
    var     ajax_timeout
    		,ajax_lost_focus
            ,ajax_search        = this
            ,search_input_id    = bc_search_config.search_input.length   > 0   ? bc_search_config.search_input    : '.bc-product-search'
            ,wrapper_id         = bc_search_config.result_wrapper.length > 0   ? bc_search_config.result_wrapper  : '.result-ajax-search'
            ,result_id          = bc_search_config.result_element.length > 0   ? bc_search_config.result_element  : '.search-results'
            ;

    jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
      var _keyword           = jQuery(this).val().trim()
          ,search_element    = jQuery(this)
          ,result_wrapper    = jQuery( wrapper_id )
          ,result_element    = result_wrapper.children( result_id );
        
      if( ajax_timeout ){ 
        clearTimeout(ajax_timeout);
      } 

      //wait 100 mili seconds to avoid request too much search
      ajax_timeout = setTimeout(function() {
        if( _keyword.length < 1 ){
          $('.result-ajax-search').hide();
        }
        
        else if( _keyword.length >= 2 ){
            jQuery(this).removeClass('error warning valid').addClass('valid');
            jQuery('.searchbox').addClass("s-loading");
            ajax_search.ajaxProductItems( search_element ,result_wrapper, result_element );
        }else{
            jQuery(this).removeClass('error warning valid').addClass('error');
          	$('.result-ajax-search').show();
            result_element.html('<li><p>Du må oppgi minst to tegn.</p></li>');
        } 
      },100);      
    }); 

    jQuery( document ).delegate( '.search-form,.result-ajax-search' ,'blur',function( event ){
        
      var _search_block = jQuery(this);
      if( ajax_lost_focus ){ 
        clearTimeout(ajax_lost_focus);
      } 

      //wait 300 mili seconds to avoid request too much search
      ajax_lost_focus = setTimeout(function() {
		jQuery('.result-ajax-search').hide();
      },200);       
    });


    
  }

  ,init : function( bc_search_config ){
    this.ajaxSearch( bc_search_config );
  }
}


AT_AjaxSearch.init({
  "search_input"      :   ".bc-product-search"
  ,"result_wrapper"   :   ".result-ajax-search"
  ,"result_element"   :   ".search-results"
  ,"strictly_mode"    :   0
});
